module.exports = __webpack_public_path__ + "img/Eclipse-2L-10-584x584.d5772386.webp";